import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Fotter } from '../../components';
import axios from "axios";

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await axios.get("http://127.0.0.1:8000/api/blog/"); // URL backendga qarab
        setBlogs(res.data);
      } catch (error) {
        console.error("Bloglarni olishda xatolik:", error);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <>
      <section className="py-36">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <h2 className="font-manrope text-4xl font-bold text-gray-900 text-center mb-14">
            Bizning mashhur bloglarimiz
          </h2>
          <div className="flex justify-center mb-14 gap-y-8 lg:gap-y-0 flex-wrap md:flex-wrap lg:flex-nowrap lg:flex-row lg:justify-between lg:gap-x-8">
            {blogs.map((blog) => (
              <Link 
                key={blog._id} 
                to={`/blog/${blog.slug}`} 
                className="group block w-full max-w-lg border border-gray-300 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition"
              >
                <img src={`http://127.0.0.1:8000${blog.photo}`} alt={blog.title} className="w-full h-52 object-cover" />
                <div className="p-5">
                  <h4 className="text-xl font-semibold text-gray-900 group-hover:text-indigo-600 transition">
                    {blog.description}
                  </h4>
                  <div className="flex justify-between text-sm text-gray-500 mt-4">
                    <span>By {blog.owner}</span>
                    <span className="text-indigo-600">{blog.date}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Fotter />
    </>
  );
};

export default BlogPage;
